<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="16"
    viewBox="0 0 11 16"
    fill="none"
  >
    <path
      d="M7.98546 11.5396L8.21997 13.3109H2.69922V2.6832H8.21997L7.98546 4.45448H4.07941V11.5396H7.98546ZM7.98546 4.45448H10.26V11.5396H7.98546V4.45448Z"
      fill="url(#paint0_linear_6540_94)"
    />
    <rect
      x="4.48047"
      y="-0.000396729"
      width="15.9992"
      height="1.78248"
      transform="rotate(90 4.48047 -0.000396729)"
      fill="url(#paint1_linear_6540_94)"
    />
    <rect
      x="5.37109"
      y="3.78476"
      width="8.17567"
      height="1.78248"
      transform="rotate(90 5.37109 3.78476)"
      fill="url(#paint2_linear_6540_94)"
    />
    <rect
      x="6.76001"
      y="-0.000518799"
      width="4.24898"
      height="1.40542"
      transform="rotate(90 6.76001 -0.000518799)"
      fill="url(#paint3_linear_6540_94)"
    />
    <rect
      x="6.75977"
      y="11.5348"
      width="4.46577"
      height="1.40542"
      transform="rotate(90 6.75977 11.5348)"
      fill="url(#paint4_linear_6540_94)"
    />
    <rect
      y="2.6832"
      width="9.34309"
      height="1.778"
      fill="url(#paint5_linear_6540_94)"
    />
    <rect
      y="11.5348"
      width="9.34309"
      height="1.778"
      fill="url(#paint6_linear_6540_94)"
    />
    <rect
      x="6.76001"
      y="9.75562"
      width="2.58342"
      height="1.778"
      fill="url(#paint7_linear_6540_94)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6540_94"
        x1="2.69922"
        y1="7.99706"
        x2="10.26"
        y2="7.99706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF246" />
        <stop
          offset="0.37"
          stop-color="#E5B80B"
        />
        <stop
          offset="0.685"
          stop-color="#FFF571"
        />
        <stop
          offset="1"
          stop-color="#E5B80B"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6540_94"
        x1="4.48047"
        y1="0.890845"
        x2="20.4797"
        y2="0.890845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF246" />
        <stop
          offset="0.37"
          stop-color="#E5B80B"
        />
        <stop
          offset="0.685"
          stop-color="#FFF571"
        />
        <stop
          offset="1"
          stop-color="#E5B80B"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6540_94"
        x1="5.37109"
        y1="4.676"
        x2="13.5468"
        y2="4.676"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF246" />
        <stop
          offset="0.37"
          stop-color="#E5B80B"
        />
        <stop
          offset="0.685"
          stop-color="#FFF571"
        />
        <stop
          offset="1"
          stop-color="#E5B80B"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6540_94"
        x1="6.76001"
        y1="0.702192"
        x2="11.009"
        y2="0.702192"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF246" />
        <stop
          offset="0.37"
          stop-color="#E5B80B"
        />
        <stop
          offset="0.685"
          stop-color="#FFF571"
        />
        <stop
          offset="1"
          stop-color="#E5B80B"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_6540_94"
        x1="6.75977"
        y1="12.2375"
        x2="11.2255"
        y2="12.2375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF246" />
        <stop
          offset="0.37"
          stop-color="#E5B80B"
        />
        <stop
          offset="0.685"
          stop-color="#FFF571"
        />
        <stop
          offset="1"
          stop-color="#E5B80B"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_6540_94"
        x1="0"
        y1="3.57219"
        x2="9.34309"
        y2="3.57219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF246" />
        <stop
          offset="0.37"
          stop-color="#E5B80B"
        />
        <stop
          offset="0.685"
          stop-color="#FFF571"
        />
        <stop
          offset="1"
          stop-color="#E5B80B"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_6540_94"
        x1="0"
        y1="12.4238"
        x2="9.34309"
        y2="12.4238"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF246" />
        <stop
          offset="0.37"
          stop-color="#E5B80B"
        />
        <stop
          offset="0.685"
          stop-color="#FFF571"
        />
        <stop
          offset="1"
          stop-color="#E5B80B"
        />
      </linearGradient>
      <linearGradient
        id="paint7_linear_6540_94"
        x1="6.76001"
        y1="10.6446"
        x2="9.34343"
        y2="10.6446"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF246" />
        <stop
          offset="0.37"
          stop-color="#E5B80B"
        />
        <stop
          offset="0.685"
          stop-color="#FFF571"
        />
        <stop
          offset="1"
          stop-color="#E5B80B"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
<script setup lang="ts">
</script>